/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { css, jsx } from '@emotion/core'
import React from 'react'
import { SectionHeader, SectionBody, } from '../twd/twd'


export const Assumptions = () => {
    const [showSection, setShowSection_] = React.useState(false)
    const setShowSection = React.useCallback((m) => {
        setShowSection_(m)
    }, [])

    return <React.Fragment>
    <div className="row"><div className="col-xs-12">
        <SectionHeader
            title="Assumptions"
            cls="subhead"
            arrowSize='medium'
            show={showSection} setShow={setShowSection}
        />
    </div></div>

    <SectionBody show={showSection}>
    <div className="row"><div className="col-md-12" css={listCss}>
        The Taxable Equivalent Yield Calculator Tool (the “Tool”) assumes the following:
        <ul>
        <li><u>In-State Municipal Bonds</u> will always be treated as fully tax exempt from federal, state, and local taxes.</li>
        <li><u>Out-of-State Municipal Bonds</u> will always be treated as subject to state and local income tax.</li>
        <li><u>Treasury Bonds</u> will always be treated as federally taxable and exempt from state and local taxes.</li>
        <li><u>Corporate Bonds</u> will always be treated as fully taxable, subject to federal, state, and local taxes.</li>
        <li>The Tool and its corresponding calculations does not take into consideration:
            <ul>
            <li>Federal Net Investment Income Tax</li>
            <li>Federal or State Alternative Minimum Tax (AMT)</li>
            <li>Effects of capital gains taxes (all bonds remain at par value)</li>
            <li>The effects of investment fees or related expenses</li>
            <li>Other specialized/unique tax treatments</li>
            </ul>
        </li>
        <li>The Tool assumes positions are held outside of retirement and other tax-deferred/sheltered investment accounts.</li>
        <li>All tax rates are rounded to nearest hundredth of a percent.</li>
        </ul>
    </div></div>

    <div className="xs-show row vertical-offset-sm"></div>
    </SectionBody>

    </React.Fragment>
}

export const listCss = css`
    li { padding: 0 }
`


export const Disclosures = () => {
    const [showSection, setShowSection_] = React.useState(false)
    const setShowSection = React.useCallback((m) => {
        setShowSection_(m)
    }, [])


    return <React.Fragment>
    <div className="row"><div className="col-xs-12">
        <SectionHeader
            title="Important disclosures and footnotes"
            cls="subhead"
            arrowSize='medium'
            show={showSection} setShow={setShowSection}
        />
    </div></div>

    <SectionBody show={showSection}>
    <div className="row"><div className="col-md-12">
        <p>The Tool is provided by a third party that is not affiliated with Morgan Stanley.  The Tool and its corresponding calculations are for educational purposes only. The information provided by the Tool neither is, nor should be construed as, an offer, or a solicitation of an offer, or a recommendation, to buy or sell securities or other instruments by Morgan Stanley. Unless stated otherwise, no information presented by the Tool constitutes a recommendation by Morgan Stanley to buy, sell, or hold any security, financial product, or instrument discussed therein, or to open a particular account or to engage in any specific investment strategy.  You understand and agree that Morgan Stanley has no liability whatsoever for the results of your investment strategies, transactions, and decisions.</p>

        <p>The results provided by the Tool are estimates based on the client’s inputs and the assumptions made by the Tool as described in “Assumptions”.</p>

        <p>This Tool is intended for US individual investors and taxpayers. It is not applicable to persons or entities residing outside of the US or otherwise subject to special income tax regulations.  Each client’s tax implications are unique and may not be fully represented by this Tool.  Morgan Stanley and its affiliates do not provide tax advice, and nothing in this section should be construed as tax advice.  Please consult with your tax professional before acting on any such information.</p>

        <p>Morgan Stanley does not guarantee that the content and yields are accurate, complete, or timely.  Federal, state, and local tax laws are subject to frequent change.  Morgan Stanley is not liable for any losses arising out of or related to your use of the Tool.</p>
    </div></div>
    <div className="xs-show row vertical-offset-sm"></div>
    </SectionBody>
    </React.Fragment>
}